import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import {Locale, useLocale} from "../../Providers/LocaleProvider";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import useMediaQuery from "@mui/material/useMediaQuery";
import {DrawerMenuItem} from "./DrawerMenuItem";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons/faChevronRight";
import {useTheme} from "../../Providers/Theme";
import {NavLink} from "react-router-dom";
import {faHome} from "@fortawesome/free-solid-svg-icons/faHome";
import {faLayerGroup} from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import {faCogs} from "@fortawesome/free-solid-svg-icons/faCogs";
import {faAd} from "@fortawesome/free-solid-svg-icons/faAd";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons/faCreditCard";
import {faBell} from "@fortawesome/free-solid-svg-icons/faBell";
import {SadeemLogo} from "../SadeemLogo";
import {faUserGear} from "@fortawesome/free-solid-svg-icons/faUserGear";
import {Logo} from "components/Logo";
import {faCartFlatbed} from "@fortawesome/free-solid-svg-icons/faCartFlatbed";
import {faStore} from "@fortawesome/free-solid-svg-icons/faStore";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {faClipboard} from "@fortawesome/free-solid-svg-icons/faClipboard";
import {faChartLine} from "@fortawesome/free-solid-svg-icons/faChartLine";
import {useRole} from "../../Providers/Role";
import {faSackDollar} from "@fortawesome/free-solid-svg-icons/faSackDollar";
import {faReceipt} from "@fortawesome/free-solid-svg-icons/faReceipt";
import {faUsers} from "@fortawesome/free-solid-svg-icons/faUsers";
import {faFileInvoiceDollar} from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";


export const DrawerContent: React.FC<{
    toggleCollapsed?: () => any,
    collapsed: boolean;
}> =
    ({
         collapsed,
         toggleCollapsed,
     }) => {
        const {theme, setThemeOptions, themeOptions} = useTheme();
        const mobile = useMediaQuery(theme.breakpoints.down('md'))
        const {locale, setLocale} = useLocale();

        const role = useRole()

        useEffect(() => {
            setThemeOptions({
                ...themeOptions,
                direction: locale === 'ar' ? 'rtl' : 'ltr'
            })
        }, [locale])

        // const themeModeButton = useMemo(() => {
        //     switch (themeMode) {
        //         case 'light':
        //             return {
        //                 icon: <FontAwesomeIcon icon={faSun}/>,
        //                 label: <Locale>theme.light</Locale>
        //             }
        //         case 'dark':
        //             return {
        //                 icon: <FontAwesomeIcon icon={faMoon}/>,
        //                 label: <Locale>theme.dark</Locale>
        //             }
        //         default:
        //             return {
        //                 icon: <FontAwesomeIcon icon={faAdjust}/>,
        //                 label: <>
        //                     {prefersDarkMode ? <Locale>theme.dark</Locale> :
        //                         <Locale>theme.light</Locale>} (<Locale>theme.system</Locale>)
        //                 </>
        //             }
        //     }
        // }, [themeMode, prefersDarkMode])

        return <>
            <Logo
                className={"logo-image"}
                style={{
                    fontSize: "100px",
                    width: "clamp(1em, 100%, 90px)",
                    maxWidth: '100%',
                    aspectRatio: '1',
                    margin: "auto",
                    marginInlineEnd: '0',
                    padding: "10px",
                    color: 'inherit',
                    height: "auto"
                }}
            />
            <DrawerMenuItem
                icon={<FontAwesomeIcon icon={faHome}/>}
                label={<Locale>home.title</Locale>}
                component={NavLink}
                to={"/"} end/>

            {/*<DrawerMenuItem*/}
            {/*    icon={<FontAwesomeIcon icon={faAd}/>}*/}
            {/*    label={<Locale>banners.title</Locale>}*/}
            {/*    component={NavLink}*/}
            {/*    to={"/banners"}/>*/}


            <DrawerMenuItem
                icon={<FontAwesomeIcon icon={faLayerGroup}/>}
                label={<Locale>service_providers_categories.title</Locale>}
                component={NavLink}
                to={"/service_providers_categories"}/>

            {
                role === 'admin' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faCreditCard}/>}
                    label={<Locale>cards_categories.title</Locale>}
                    component={NavLink}
                    to={"/cards_categories"}/>
            }


            {
                role === 'admin' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faCartFlatbed}/>}
                    label={<Locale>service_providers.title</Locale>}
                    component={NavLink}
                    to={"/service_providers"}/>
            }

            <DrawerMenuItem
                icon={<FontAwesomeIcon icon={faStore}/>}
                label={<Locale>{`users.${role === 'accountant' ? 'accountant_title' : 'title'}`}</Locale>}
                component={NavLink}
                to={"/users"}/>
            <DrawerMenuItem
                icon={<FontAwesomeIcon icon={faClipboard}/>}
                label={<Locale>transactions.title</Locale>}
                component={NavLink}
                to={"/transactions"}/>


            {
                role === 'accountant' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faSackDollar}/>}
                    label={<Locale>sales.title</Locale>}
                    component={NavLink}
                    to={"/sales"}/>
            }

            {
                role === 'accountant' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faReceipt}/>}
                    label={<Locale>purchases.title</Locale>}
                    component={NavLink}
                    to={"/purchases"}/>
            }

            {
                role === 'accountant' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faUsers}/>}
                    label={<Locale>employees_salaries.title</Locale>}
                    component={NavLink}
                    to={"/employees"}/>
            }

            {
                role === 'accountant' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faFileInvoiceDollar}/>}
                    label={<Locale>expenses.title</Locale>}
                    component={NavLink}
                    to={"/expenses"}/>
            }

            {
                role === 'admin' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faChartLine}/>}
                    label={<Locale>cards_statistics.title</Locale>}
                    component={NavLink}
                    to={"/cards_statistics"}/>
            }

            {
                role === 'admin' &&
                <DrawerMenuItem
                    icon={<FontAwesomeIcon icon={faBell}/>}
                    label={<Locale>notifications.send_notification</Locale>}
                    component={NavLink}
                    to={"/notifications"}/>
            }

            <Divider/>
            {/*<DrawerMenuItem*/}
            {/*    icon={<FontAwesomeIcon icon={faCogs}/>}*/}
            {/*    label={<Locale>settings.title</Locale>}*/}
            {/*    component={NavLink}*/}
            {/*    to={"/settings"}/>*/}
            {/*<Divider/>*/}
            <Box flex={1}/>
            {
                toggleCollapsed &&
                <Button
                    className="collapse-button"
                    size={"large"}
                    color={"inherit"}
                    onClick={toggleCollapsed}>
                    <Box flex={1}/>
                    <FontAwesomeIcon size={"lg"} icon={faChevronRight}/>
                </Button>
            }
        </>
    }
